import { ReactElement } from 'react';

import { Dropdown, LinkSize } from '@dreryk/react-components';
import { TranslatableText } from '@dreryk/react-common';

import { StyledLink } from './AdvancePaymentIssueActionLink.styled';

export type AdvancePaymentActionVariant = 'link' | 'dropdownItem';

type AdvancePaymentActionTriggerProps = {
   readonly variant: AdvancePaymentActionVariant;
   readonly label: TranslatableText;
   readonly testId: string;
   readonly icon?: ReactElement;
};

export const AdvancePaymentActionTrigger = (props: AdvancePaymentActionTriggerProps): ReactElement => {
   const handleClick = (hide: VoidFunction): void => {
      hide();
   };

   if (props.variant === 'dropdownItem') {
      return (
         <Dropdown.Item testId={props.testId} onClick={handleClick}>
            {props.label}
         </Dropdown.Item>
      );
   }

   return <StyledLink size={LinkSize.NORMAL} testId={props.testId} label={props.label} icon={props.icon} />;
};
